export default __webpack_public_path__ + "static/media/Thumb-5.0b696acb.png";